import { GetForwardRefExoticComponentProps } from "types";
import { createButton } from "./ButtonBase";

type HTMLButtonAttributes = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export type ButtonProps = GetForwardRefExoticComponentProps<typeof Button>;
export const Button = createButton<HTMLButtonElement, HTMLButtonAttributes>("button");
